import React from 'react';
import './index.scss';

import Video2017 from './../../media/2017.mp4';
import VideoRodeo from './../../media/rodeo.mp4';
import VideoJazzbio from './../../media/jazzbio.mp4';
import VideoPeopleVentures from './../../media/peopleventures.mp4';
import VideoNaboskaber from './../../media/naboskaber.mp4';
import VideoLetsLevitate from './../../media/letslevitate.mp4';
import VideoPortfolio from './../../media/portfolio.mp4';

const cases = [
	{
		video: VideoRodeo,
		title: 'Rodeo Architects',
		data: 'Featured on SiteInspire. Oslo-based Architects. React, headless Wordpress. In collaboration with BWD Studio. <a href="https://www.rodeo-arkitekter.no/" target="_blank">rodeo-arkitekter.no</a>'
	},
	{
		video: VideoLetsLevitate,
		title: 'Lets Levitate',
		data: '"Site of the Week" on SiteInspire. High-performance prosthetic feet. Nextjs, headless Shopify. In collaboration with Gustav Nordebrink, Tyge Vonsbæk & T For Troels. <a href="https://letslevitate.com/" target="_blank">letslevitate.com</a> (not current site)'
	},
	{
		video: VideoPeopleVentures,
		title: 'People Ventures',
		data: 'Programming, animation. React, headless Wordpress. In collaboration with BWD Studio. <a href="https://people.ventures/" target="_blank">people.ventures</a>'
	},
	{
		video: Video2017,
		title: 'Aarhus 2017',
		data: 'Interactive visualization for the European Capital of Culture. d3js. Programming, ux, animation. In collaboration with Hele Vejen.'
	},
	{
		video: VideoPortfolio,
		title: 'Portfolio',
		data: 'Playable portfolio concept with build in sample-instrument and sequencer. Personal project. Concept, ux, design, music & programming. React, Konva.js. <a href="https://www.troelsknud.dk/portfolio/" target="_blank">troelsknud.dk/portfolio</a>'
	},
	{
		video: VideoJazzbio,
		title: 'Jazzbio',
		data: 'Online cinema for school children. Aarhus Jazzorkester. UX, design & programming. Nextjs. <a href="https://www.jazzbio.dk/" target="_blank">jazzbio.dk</a>'
	},
	{
		video: VideoNaboskaber,
		title: 'Naboskaber',
		data: 'Platform for the creation of co-living housingprojects. UX, design & programming. Nextjs, Firebase. <a href="https://www.naboskaber.dk/" target="_blank">naboskaber.dk</a>'
	}
]

function Work() {
  return (
    <div className="section work" id="work">
        <div className="anchor-wrapper">
            <div className="anchor"/>
        </div>
        <div className="inner">
            <h1 className="headline">selected work</h1>
            <div className="content">
            	{cases.map((ele, i) => (
	                <div className="case" key={i}>
	                    <video autoPlay src={ele.video} muted loop playsInline/>
	                    <div className="title">{ele.title}</div>
	                    <div className="data" dangerouslySetInnerHTML={{__html:ele.data}}/>
	                </div>
        		))}
            </div>
        </div>
    </div>
  );
}

export default Work;
